// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_br-4";
export var collapsed = "_br-1";
export var headerBar = "_br-0";
export var leftHeaderContent = "_br-3";
export var subjectContainer = "_br-2";